import { NavLink, useLocation } from 'react-router-dom';
import { Home, Music, Users, Settings, LogOut, ListMusic, Mic2, Download, MessageSquare, Image } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { cn } from '@/lib/utils';

interface NavItem {
  path: string;
  label: string;
  icon: React.ReactNode;
}

export function MobileNav() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const isAdmin = user?.role === 'SUPERADMIN' || user?.role === 'MUZIEKCOMMISSIE';
  const hasDirigentAccess = user?.role && ['DIRIGENT', 'MUZIEKCOMMISSIE', 'SUPERADMIN'].includes(user.role);

  const navItems: NavItem[] = [
    { path: '/', label: 'Home', icon: <Home className="w-5 h-5" /> },
    { path: '/repertoire', label: 'Repertoire', icon: <Music className="w-5 h-5" /> },
    { path: '/playlists', label: 'Lijsten', icon: <ListMusic className="w-5 h-5" /> },
    { path: '/downloads', label: 'Downloads', icon: <Download className="w-5 h-5" /> },
    { path: '/berichten', label: 'Berichten', icon: <MessageSquare className="w-5 h-5" /> },
    { path: '/media', label: 'Media', icon: <Image className="w-5 h-5" /> },
    ...(hasDirigentAccess ? [{ path: '/dirigent', label: 'Dirigent', icon: <Mic2 className="w-5 h-5" /> }] : []),
    { path: '/smoelenboek', label: 'Leden', icon: <Users className="w-5 h-5" /> },
    ...(isAdmin ? [{ path: '/admin', label: 'Admin', icon: <Settings className="w-5 h-5" /> }] : []),
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-bg-elevated border-t border-subtle z-40 safe-area-bottom">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={cn(
                'flex flex-col items-center justify-center py-2 px-3 min-w-[64px] transition-colors',
                isActive ? 'text-zzing-purple-500' : 'text-text-secondary'
              )}
            >
              {item.icon}
              <span className="text-xs mt-1 font-medium">{item.label}</span>
            </NavLink>
          );
        })}
        <button
          onClick={logout}
          className="flex flex-col items-center justify-center py-2 px-3 min-w-[64px] text-text-secondary transition-colors"
        >
          <LogOut className="w-5 h-5" />
          <span className="text-xs mt-1 font-medium">Uit</span>
        </button>
      </div>
    </nav>
  );
}
